export function textColorPicker(backgroundColor: string) {
  if (!backgroundColor) {
    return '#fff';
  }
  let result = Number.parseInt(backgroundColor.replace('#', ''), 16);
  const color: { R: number; G: number; B: number } | null = result
    ? {
        R: result ? (result >> 16) & 255 : 1,
        G: result ? (result >> 8) & 255 : 1,
        B: result ? result & 255 : 1,
      }
    : null;

  let d = '';
  let luminance = 0;
  if (color) {
    luminance = (0.299 * color.R + 0.587 * color.G + 0.114 * color.B) / 255;
  }
  if (luminance > 0.5) {
    d = '#000000';
  } else {
    d = '#ffffff';
  }

  return d;
}



 export function getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
